import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import uuid from 'react-uuid';
import { useViewport } from '../hooks/viewportContext';

const Navbar = (
  {
    data = [{ name: "Home", href: "/" }, { name: "Feedback", href: "feedback"}],
    backGroundColor = "bg-th-blue",
    textColor = "text-th-white",
    linkColor = "text-th-white-900",
    linkColorActive = "text-th-white",
    fillColor = "fill-th-white",
  }) => {

  const [navbarOpen, setNavbarOpen] = useState(false);
  const { width } = useViewport();

  //Set navbarOpen to false when window width is greater than 768px
  useEffect(() => {
    if (width > 768) {
      setNavbarOpen(false)
    }
  }, [width])

  const navLinksComponent = data.map((x, index) => {
    return (
      <li key={uuid()} >
        <NavLink to={x.href}
          id={`${x.name}-${index}`}
          className={({isActive}) => `
          ${isActive ? "text-th-white" : "text-th-white-900"}
          rounded 
          block py-2 pl-3 pr-4 
          md:border-0 
          md:p-0`}
          aria-current="page">{x.name}</NavLink>
      </li>
    )
  })

  return (
    <nav className=
      {
        `border-gray-200 
      px-2 sm:px-4 
      py-2.5 
      ${backGroundColor}`
      }>
      <div className="
  container 
  flex 
  flex-wrap 
  items-center 
  justify-between 
  md:justify-start
  md:space-x-20
  mx-auto">
        <a href="https://nielsvandervelden.com/"
          className="flex items-center">
          <img src="bermuda.png" className="h-6 mr-3 sm:h-9" alt="Logo" />
          <span className={`
        self-center 
        text-xl 
        ${textColor}
        font-semibold 
        whitespace-nowrap`}>Bermuda GOV Salaries</span>
        </a>
        <button data-collapse-toggle="navbar-default"
          type="button"
          onClick={() => setNavbarOpen(prev => !prev)}
          className={`
    inline-flex 
    items-center 
    p-2 
    ml-3 
    text-lg 
    ${fillColor}
    rounded-lg 
    md:hidden`}
          aria-controls="navbar-default"
          aria-expanded="false">
          <span className="sr-only">Open main menu</span>
          <svg className="w-6 h-6"
            aria-hidden="true"
            fillRule="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"></path></svg>
        </button>
        <div className="hidden w-full md:block md:w-auto" id="navbar-default">
          <ul className={`
      flex 
      flex-col 
      p-4 
      mt-4 
      border 
      border-gray-100 
      rounded-lg 
      md:flex-row 
      md:space-x-8 
      md:mt-0 
      md:text-sm 
      md:font-medium 
      md:border-0 
      md:${backGroundColor}`} >
            {navLinksComponent}
          </ul>
        </div>
        <div className={`${navbarOpen ? "w-full" : "hidden w-full"} md:hidden`} id="navbar-hamburger">
          <ul className="flex flex-col mt-4 rounded-lg">
            {navLinksComponent}
          </ul>
        </div>
      </div>
    </nav>
  )
};

export default Navbar;